import { jsxs as t, jsx as i } from "react/jsx-runtime";
import _ from "react";
import { u as k, I as s } from "./useMediaQuery-BZAMobKw.js";
import { I as l } from "./Section-DOeCOW54.js";
const p = "elo-tablet", f = "elo-desktop", a = {
  "social-links": "elo-social-links",
  tablet: p,
  desktop: f,
  "social-links__social": "elo-social-links__social",
  "social-links__social-icon": "elo-social-links__social-icon"
}, g = _.forwardRef(
  ({ facebook: o, instagram: e, linkedin: c, externalLink: n, externalLinkText: r, ...d }, h) => {
    const m = k("(max-width: 600px)");
    return /* @__PURE__ */ t("div", { ref: h, className: a["social-links"], ...d, children: [
      /* @__PURE__ */ t("div", { className: a["social-links__social"], children: [
        e && /* @__PURE__ */ i(
          s,
          {
            variant: "primary",
            href: e,
            target: "_blank",
            className: a["social-links__social-icon"],
            children: /* @__PURE__ */ i(l, { name: "Instagram", height: "24px", width: "24px" })
          }
        ),
        o && /* @__PURE__ */ i(
          s,
          {
            variant: "primary",
            href: o,
            target: "_blank",
            className: a["social-links__social-icon"],
            children: /* @__PURE__ */ i(l, { name: "Facebook", height: "24px", width: "24px" })
          }
        ),
        c && /* @__PURE__ */ i(
          s,
          {
            variant: "primary",
            href: c,
            target: "_blank",
            className: a["social-links__social-icon"],
            children: /* @__PURE__ */ i(l, { name: "Linkedin", height: "24px", width: "24px" })
          }
        )
      ] }),
      /* @__PURE__ */ i("div", { children: n && /* @__PURE__ */ i(
        s,
        {
          variant: "secondary",
          small: !!m,
          href: n,
          iconLeft: "ExternalLink",
          children: r
        }
      ) })
    ] });
  }
);
export {
  g as S
};
